import { Store } from 'vuex';

let store: Store<unknown>;

export function initStore (initStore): void {
  store = initStore;
}

export function useStore (): Store<unknown> {
  return store;
}
